<template>
  <div class="testing">
    <div @click="me">点我</div>
    <!--<div @click="remove">移除</div>-->
    <div id="list-demo" class="demo">
      <transition-group name="fade" tag="ul">
          <li v-for="(item,index) in items" v-bind:key="item" class="list-item">
            <div> {{ item }}</div>
            <div class="maskLeft">
              <div class="imgBox">
              </div>
              <div class="remove" v-on:click="removeC(index)">
                <img :src="require('@/assets/homeImg/wdgwd_icon_close@2x.png')" alt="">
                <span>移除</span>
              </div>
            </div>
            <div class="maskRight">
              <div class="maskRightHead">
                <span>奢華群鑲鑽戒</span>
                <span class="maskAmount">x1</span>
              </div>
              <div class="chooseDetail">
                <div>
                  <div>顏色 白金 </div>
                  <div>尺寸 12号</div>
                </div>
              </div>
              <div class="unitPrice">$3,999{{item}}</div>
              <div class="maskLine"></div>
            </div>
          </li>
      </transition-group>

    </div>

  </div>
</template>

<script>

    export default {
      name: "Texting",
      data(){
          return{
           arr:['c','b','r','g'],
            show: true,
            items: [1,2,3,4,5,6,7,8,9],
            nextNum: 10
        }
      },
      methods:{
        randomIndex: function () {
          return Math.floor(Math.random() * this.items.length)
        },
        add: function () {
          // this.items.splice(this.randomIndex(), 0, this.nextNum++)
        },
        // remove: function () {
        //   this.items.splice(this.randomIndex(), 1)
        // },
        me() {
          this.arr.remove('d');
          console.log(this.arr);
        },
        // remove(arr){
        //
        //   this.arr.splice(this.arr.indexOf('g'),1);
        //   console.log(this.arr);
        // },
        removeC(index) {
          this.items.splice(index,1);
          console.log(this.items);
        }
      }
    }
</script>

<style scoped>
  .testing {
    width: 500px;
    height: 500px;
    margin: 0 auto;
    padding-top: 100px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .slide-enter, .slide-leave-to {

  }
  .slide-leave, .slide-enter-to {

  }
  .slide-enter-active {
    animation: slide-in 2s ease-out;
  }
  .slide-leave-active {
    animation: slide-out 2s ease-out;
    /* 这里在离开的时候，需要让这个元素脱离标准流，不然后面的元素动不了 */
    position: absolute;
  }
  /* 想要让动画平滑一点，需要加v-move的类名，v-可以别name的值 */
  .slide-move {
    transition: all 2s;
  }

  @keyframes slide-in {
    from {
      transform: translateY(50px)
    }
    to {
      transform: translateY(0)
    }
  }
  @keyframes slide-out {
    from {
      transform: translateY(0)
    }
    to {
      transform: translateY(50px)
    }
  }


  list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
    /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Texting.vue